export default "__VITE_ASSET__BCdotPsZ__"